export const HOME_SPLINE_SCENE_EN =
  'https://prod.spline.design/d9aacl6REVQwhs-9/scene.splinecode';

export const HOME_SPLINE_SCENE_KA =
  'https://prod.spline.design/N0skPEKwMuLaJJSp/scene.splinecode';

export const LIST_SPLINE_SCENE_URL =
  'https://prod.spline.design/hm0tAYOdJgUknDMY/scene.splinecode';

export const NOT_FOUND_SPLINE_SCENE_URL =
  'https://prod.spline.design/vEDOKGPBBn6EpLfk/scene.splinecode';

const LIST_SPLINE_PAGE_PATHS = new Set([
  '/services',
  '/about/equipment',
  '/history/our-work',
  '/history/blogs',
]);

export function shouldShowLayoutSplineBackground(pathname) {
  return LIST_SPLINE_PAGE_PATHS.has(pathname);
}

export function getHomeSplineSceneUrl() {
  // Both language versions used to load separate Spline scene files, but they
  // don't position the "GFM STUDIO" title/logo identically, so the layout
  // visibly shifted when switching languages. The Georgian scene's layout is
  // the one to keep, so use it for both languages now.
  return HOME_SPLINE_SCENE_KA;
}

export function getLayoutSplineSceneUrl() {
  return LIST_SPLINE_SCENE_URL;
}

export function getNotFoundSplineSceneUrl() {
  return NOT_FOUND_SPLINE_SCENE_URL;
}
